import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorLiquidityMining = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="m9.293 7.659-3.157 4.058.488 2.441a.75.75 0 1 1-1.47.295l-.502-2.509a1.35 1.35 0 0 1 .258-1.094l3.303-4.246a1.35 1.35 0 0 1 2.02-.126l5.206 5.206a1.35 1.35 0 0 1 0 1.91l-2.809 2.808c-.148.148-.328.26-.527.326l-1.533.511a.75.75 0 0 1-.474-1.423l1.499-.5 2.678-2.677-4.98-4.98Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M2 14.111a.75.75 0 0 0 0 1.5h5.76c.36 0 .702.156.94.427l2.694 3.078a2.75 2.75 0 0 0 2.07.94H22a.75.75 0 0 0 0-1.5h-8.537a1.25 1.25 0 0 1-.94-.427L9.828 15.05a2.75 2.75 0 0 0-2.07-.939H2Zm14.806 1.861a.75.75 0 0 1 .75-.75H22a.75.75 0 0 1 0 1.5h-4.444a.75.75 0 0 1-.75-.75ZM1.25 19.305a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75ZM14.803 2.664a.75.75 0 0 1 1.06 0l3.334 3.333a.75.75 0 0 1-1.06 1.061L17 5.922l-6.692 6.692a.75.75 0 0 1-1.06-1.061l6.691-6.692-1.136-1.136a.75.75 0 0 1 0-1.061Z"
    />
  </svg>
);
export default SvgTwoColorLiquidityMining;
